import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getTimeZones } from './index';

export const createTimeZonesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getTimeZones: (instance: IPublicClientApplication) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getTimeZones(fetchContext, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getTimeZones', isInFlight);
    },
  ),
});
